import { render, staticRenderFns } from "./DriversTable.vue?vue&type=template&id=1850c32c"
import script from "./DriversTable.vue?vue&type=script&lang=js"
export * from "./DriversTable.vue?vue&type=script&lang=js"
import style0 from "./DriversTable.vue?vue&type=style&index=0&id=1850c32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports